export const user = "me";
export const userPassword = "me/password";
